module.exports = __webpack_public_path__ + "static/img/xiugaiyinliang2.c211efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/xiugaiyinliang2.png
// module id = +L2H
// module chunks = 24